import styled from 'styled-components';

export const AdvertiserCampaignSkeletonStyled = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;

  .advertiserCampaignSkeleton {
    &__firstLine, &__secondLine {
      display: flex;
      flex-direction: row;
      column-gap: 16px;

      &Item {
        display: flex;
        flex-direction: column;
        flex: 1;
        row-gap: 2px;
      }
    }
  }
`;
